
export const list = (values: any) => {
    // ky_sqdata
    // sh_kojo

    // 1003
    // 1005
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `//192.168.0.202/fuelphp/public/money/rest/solist/index.json`
    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;

    return fetch(url, {
        method: 'post',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        body: JSON.stringify(values),
        // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload2 => ({ payload2 }))
        .catch(error2 => ({ error2 }));


}


export const soymdlist = (values: any) => {


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `//192.168.0.202/fuelphp/public/money/rest/solist/soymd.json`
    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
    // alert(url)
    return fetch(url, {
        method: 'get',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        // body: JSON.stringify(values),
        // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}



export const kakumeiinsert = (values: any) => {


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `//192.168.0.202/fuelphp/public/money/rest/kojolist/insert.json`
    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
    // alert(url)
    return fetch(url, {
        method: 'post',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' },
        body: JSON.stringify(values),
        // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}
